import { createFileRoute } from "@tanstack/react-router";
import OrderDetailEdit from "../../../../Screens/OrderDetailEdit";

export const Route = createFileRoute("/order/order-details/edit/$orderId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  const search = Route.useSearch() as any;
  return (
    <OrderDetailEdit
      orderId={orderId}
      restaurantIdOverride={search?.restaurantId}
    />
  );
}
